// Local Deps
import { makeGraphQLRequest } from '../utils/requestUtils';

export async function getToolAccessLevels() {
    // Format Mutation
    const query = `query toolAccessLevels { toolAccessLevels { data } }`;

    const response = await makeGraphQLRequest({
        query,
    });
    return response.toolAccessLevels.data;
}


export async function getToolCategories() {
    // Format Mutation
    const query = `query toolCategories { toolCategories { data } }`;

    const response = await makeGraphQLRequest({
        query,
    });
    return response.toolCategories.data;
}

export async function editTool({
    id,
    niin,
    partNum,
    cage,
    ownerCage,
    description,
    toolingRef,
    designAlloy,
    comments,
    accessLevel,
    category,
    modifiedBy,
}) {
    // Format Mutation
    const query = `mutation updateTool(
      $toolInput: EditToolInput
    ) {
       updateTool(tool:$toolInput)
        {
        status
        }
      }`;

    // Variables
    const variables = {
        toolInput: {
            id,
            niin,
            partNum,
            cage,
            ownerCage,
            description,
            toolingRef,
            designAlloy,
            comments,
            accessLevel,
            category,
            modifiedBy,
        },
    };

    const response = await makeGraphQLRequest({
        query,
        variables,
    });
    return response;
}



// WEBPACK FOOTER //
// ./src/graphql/tooling.js